import { Schedule } from 'shared/models';

export const Actions = {
    SAVE_SCHEDULE_SUCCESS: 'SAVE_SCHEDULE_SUCCESS',
};


export const saveScheduleSuccess = (schedule: Schedule, meta: { buildingId: string; deviceId: string }) => ({
    type: Actions.SAVE_SCHEDULE_SUCCESS,
    payload: schedule,
    meta,
});
